import { LegalPageTemplate } from '../components/legal/LegalPageTemplate';
import { JsonLd } from '../components/seo/JsonLd';
import { useLegalRegion } from '../hooks/useLegalRegion';
import { PageSeo } from '../components/seo/PageSeo';
import { LEGAL_DOCUMENTS } from '../lib/legalContent';
import { buildLegalPageSchema } from '../lib/schema';
import { TERMS_META } from '../lib/seo';

export function TermsOfServicePage() {
  const { region } = useLegalRegion();
  const content = region === 'IN' ? LEGAL_DOCUMENTS.termsIndia : LEGAL_DOCUMENTS.termsGlobal;

  return (
    <>
      <PageSeo meta={TERMS_META} />
      <JsonLd
        data={buildLegalPageSchema('Terms of Service', TERMS_META.path, '2026-05-26')}
      />
      <LegalPageTemplate
        title="Terms of Service"
        effectiveDate="June 1, 2025"
        lastUpdated="May 26, 2026"
        content={content}
      />
    </>
  );
}
